// components/Selo.jsx
import React from 'react';

const Selo = ({ icon, texto, cor }) => {
  return (
    <div
      className={`bg-${cor}-500 text-white text-xs px-2 py-1 rounded-full font-bold uppercase flex items-center gap-1 shadow-md`}
    >
      {icon} {texto}
    </div>
  );
};

export default Selo;
